import { useState } from 'react';
import { ContractModal } from '../contract/OrderContractModal/OrderContractModal';
import { SignatureContextProvider } from '../contract/contexts/signature.context';
import InfoLoader from './InfoLoader';

const PublicContractIndex = () => {
  const [open, setOpen] = useState(false);

  return (
    <SignatureContextProvider>
      <InfoLoader setOpen={setOpen} />
      <ContractModal disableContext open={open} />
    </SignatureContextProvider>
  );
};

export default PublicContractIndex;
